import { RcClasses } from '../../../foundation';
export var RcBadgeClasses = RcClasses(['badge', 'invisible'], 'RcBadge');
export var roundBadgeMarginKey = '--badge-round-margin';
var sqrt2 = Math.sqrt(2);
var powBy = sqrt2 - 1; // 0.292893218813452
/**
 * a circle inside square, that diagonal of a square to circle distance to be the round offset.
 * @param x that circle r
 * @returns the distance of that offset
 */
export var getRoundOffset = function (x) {
    return (x * powBy) / sqrt2;
};
